import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  input,
  InputSignal,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { ICorporateDesign } from '@web/dtos';
import { ButtonComponent } from '../../feedback/button/button.component';

@Component({
  selector: 'aw-sub-section',
  imports: [NgClass, ButtonComponent, NgStyle],
  templateUrl: './sub-section.component.html',
})
export class SubSectionComponent implements OnInit, AfterViewInit {
  public readonly isDarkMode: InputSignal<boolean> = input<boolean>(false);
  public readonly darkModeColor: InputSignal<string> = input<string>('#000000');
  public readonly isDisabled: InputSignal<boolean> = input<boolean>(false);
  public readonly isCollapsible: InputSignal<boolean> = input<boolean>(false);
  public readonly isInitiallyCollapsed: InputSignal<boolean> =
    input<boolean>(false);
  public readonly isStickyHeader: InputSignal<boolean> = input<boolean>(false);
  public readonly testIdAffix: InputSignal<string> = input.required<string>();
  public readonly id: InputSignal<string> = input<string>('');
  public readonly corporateDesign: InputSignal<ICorporateDesign | undefined> =
    input<ICorporateDesign | undefined>();
  public readonly forceCollapse: InputSignal<boolean | null | undefined> =
    input<boolean | null | undefined>(false);
  public readonly triggerExpandByHash: InputSignal<string | null | undefined> =
    input<string | null | undefined>();
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  public hasMultipleChildren: boolean = false;
  public isCollapsed: boolean = false;

  @ViewChild('subsection')
  protected readonly subSectionRef!: ElementRef;

  ngOnInit() {
    this.isCollapsed = this.isInitiallyCollapsed();
  }

  ngAfterViewInit() {
    this.hasMultipleChildren =
      this.subSectionRef.nativeElement.children.length > 1;
    this.cdRef.detectChanges();
  }

  toggleCollapse(): void {
    if (this.isCollapsible()) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
